import { render, staticRenderFns } from "./ProducaoDadosIniciais.vue?vue&type=template&id=4a1ff822"
import script from "./ProducaoDadosIniciais.vue?vue&type=script&lang=ts"
export * from "./ProducaoDadosIniciais.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports